export default __webpack_public_path__ + "locales/bg/ChangePhoneDialog.json?hash=161806cb232566f3874c217ee1d727f9";